import React from "react";

const Main = (props) => {
  return <main className="main-container">{props.children}</main>;
};

export default Main;
